import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../assets/images/openicon.svg'
import _imports_1 from '../../../assets/images/chat/edit-pencil.svg'
import _imports_2 from '../../../assets/images/chat/forward.svg'
import _imports_3 from '../../../assets/images/chat/calendar-icon.svg'
import _imports_4 from '../../../assets/images/chat/calendar-clock.svg'
import _imports_5 from '../../../assets/images/chat/recurrence-icon.svg'
import _imports_6 from '../../../assets/images/chat/multiple-users.svg'


const _hoisted_1 = { class: "meeting-details" }
const _hoisted_2 = { class: "d-flex align-items-center font-size-lg py-2 px-3 event-details-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Event Details", -1 /* HOISTED */)
const _hoisted_4 = { class: "event-details-body" }
const _hoisted_5 = { class: "event-details-layout mb-2" }
const _hoisted_6 = { class: "d-flex align-items-center justify-space-between fw-bold font-size-lg pb-2" }
const _hoisted_7 = { class: "meeting-actions mt-2" }
const _hoisted_8 = {
  key: 0,
  type: "button",
  id: "editMeetingMenu",
  class: "btn btn-sm meeting-btn-outline text-primary me-2",
  "data-bs-toggle": "dropdown"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "rotate-90",
  src: _imports_0
}, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  class: "dropdown-menu",
  "aria-labelledby": "editMeetingMenu"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" This event ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" All events in the series ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  id: "cancelMeetingMenu",
  class: "btn btn-sm meeting-btn-outline text-danger me-2",
  "data-bs-toggle": "dropdown"
}, [
  /*#__PURE__*/_createTextVNode(" Cancel "),
  /*#__PURE__*/_createElementVNode("img", {
    class: "rotate-90",
    src: _imports_0
  })
], -1 /* HOISTED */)
const _hoisted_20 = {
  class: "dropdown-menu",
  "aria-labelledby": "cancelMeetingMenu"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" This event ")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" All events in the series ")
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "meeting-btn-outline" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-ellipsis-h font-size-lg ms-md-1 py-1 ps-md-1 mx-2 cursor-pointer",
  "data-bs-toggle": "dropdown"
}, null, -1 /* HOISTED */)
const _hoisted_29 = {
  class: "dropdown-menu py-1",
  "aria-labelledby": "Meeting-Options"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_2
}, null, -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Forward ")
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "event-details-layout" }
const _hoisted_34 = { class: "section-underline" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h6", { class: "font-size-sm fw-semibold" }, "Details", -1 /* HOISTED */)
const _hoisted_36 = { class: "mb-1 d-flex align-items-center" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_3
}, null, -1 /* HOISTED */)
const _hoisted_38 = { class: "mb-1 d-flex align-items-center" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_4
}, null, -1 /* HOISTED */)
const _hoisted_40 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_5
}, null, -1 /* HOISTED */)
const _hoisted_42 = { class: "section-underline py-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h6", { class: "font-size-sm fw-semibold" }, "Participants", -1 /* HOISTED */)
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1 /* HOISTED */)
const _hoisted_46 = { class: "ms-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "ms-1 text-muted" }, "(organizer)", -1 /* HOISTED */)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", {
  class: "me-2",
  src: _imports_6
}, null, -1 /* HOISTED */)
const _hoisted_49 = {
  key: 0,
  class: "py-2"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h6", { class: "font-size-sm fw-semibold" }, "Description", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("i", {
        class: "ms-auto fas fa-times-circle text-danger cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog()))
      })
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.eventTitle), 1 /* TEXT */),
        _createElementVNode("section", _hoisted_7, [
          (_ctx.shouldShowJoinBtn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn btn-primary py-1 me-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.joinMeeting()))
              }, "Join"))
            : _createCommentVNode("v-if", true),
          (_ctx.isOrganizer)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.isRecurring)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.isPastEvent)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-sm meeting-btn-outline text-primary me-2",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editMeeting(false)))
                          }, " Edit "))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm meeting-btn-outline text-danger me-2",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelMeeting()))
                      }, " Cancel ")
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!_ctx.isPastEvent)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_8, _hoisted_11))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:void(0);",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editMeeting(false)))
                        }, _hoisted_15),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:void(0);",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editMeeting(true)))
                        }, _hoisted_18)
                      ]),
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:void(0);",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancelMeeting(false)))
                        }, _hoisted_23),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          href: "javascript:void(0);",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancelMeeting(true)))
                        }, _hoisted_26)
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("a", {
                class: "dropdown-item font-size-sm d-flex align-items-center",
                href: "javascript:void(0);",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.forwardMeeting && _ctx.forwardMeeting(...args)))
              }, _hoisted_32)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createTextVNode(_toDisplayString(_ctx.eventDate), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("span", null, _toDisplayString(_ctx.eventTime), 1 /* TEXT */)
          ]),
          (_ctx.isRecurring)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", null, _toDisplayString(_ctx.occurenceText(_ctx.recurrenceStartDate, _ctx.recurrenceEndDate, _ctx.recurrenceType, _ctx.daysOfWeek)), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createTextVNode(_toDisplayString(_ctx.organizerName), 1 /* TEXT */),
              _hoisted_47
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_48,
            _createElementVNode("span", null, _toDisplayString(_ctx.getParticipantNames), 1 /* TEXT */)
          ])
        ]),
        (_ctx.description.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", null, _toDisplayString(_ctx.description), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}